<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Identifier Summary
          </div>
        </template>
      </es-header>
    </div>
    <div>
      <es-loader v-if="loading"/>
      <es-exception
        v-else-if="loadingError"
        style="margin: 0"
        exceptionMessage="There was an issue.
        Please try again or contact your administrator."
      />
      <es-form v-else style="margin: 0rem 1rem">
        <template #es-form>
          <table style="width: 100%" role="presentation">
            <tbody>
              <tr>
                <td class="property has-text-grey top-row">
                  ID Pool Size
                </td>
                <td class="top-row">
                  <div class="content has-text-right is-pulled-right">
                    {{ identifierSummary.idPoolSize }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="property has-text-grey">
                  Active IDs
                </td>
                <td>
                  <div class="content has-text-right is-pulled-right">
                    {{ identifierSummary.activeIds }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="property has-text-grey">
                  Retired IDs
                </td>
                <td>
                  <div class="content has-text-right is-pulled-right">
                    {{ identifierSummary.retiredIds }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="property has-text-grey">
                  Available IDs
                </td>
                <td>
                  <div class="content has-text-right is-pulled-right">
                    {{ identifierSummary.availableIds }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    NotificationManager
  ],
  components: {
    EsForm,
    EsHeader,
    EsException,
    EsLoader
  },
  created() {
    this.onLoad();
  },
  data() {
    return {
      identifierSummary: [],
      loading: false,
      loadingError: false,
    };
  },
  methods: {
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;
        const res = await axios.get('identifier-summary');
        this.identifierSummary = res.data;
      } catch (err) {
        this.loadingError = true;
        this.messages.push('There were some errors. Please try again. If errors persist please contact support.');
        this.showNotification('danger', this.messages);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  table td
    vertical-align: middle
  table tr
    border-bottom: 1px solid #eee
  .property
    font-size: 12px
  .top-row
    padding-top: 1rem
  .has-text-right
    padding-right: 0
</style>
